import { MnemonicData } from "@custom-types/graphs"

export const getUniqueScenarios = (data: MnemonicData) => {
  const scenarioIndex = getScenarioColumnIndex(data)

  const scenarios = data.rows
    .filter((row) => row[scenarioIndex]) // filter out null values
    .map((row) => row[scenarioIndex]) as string[]

  return Array.from(new Set(scenarios))
}

export const getScenarioColumnIndex = (data: MnemonicData) => {
  return data.columns.findIndex((column) => column === "Scenario")
}

export const getMnemColumnIndex = (data: MnemonicData) => {
  return data.columns.findIndex((column) => column === "Mnem")
}

export const mergeMnemonicDataWithEmbeddedScenario = (
  data: MnemonicData,
  scenario: Record<string, string>[],
): MnemonicData => {
  const mergedData = structuredClone(data)
  const dateIndex = data.columns.findIndex((column) => column === "Date")
  const valueIndex = data.columns.findIndex((column) => column === "Value")
  const scenarioIndex = data.columns.findIndex((column) => column === "Scenario")

  mergedData.rows.forEach((row) => {
    const date = row[dateIndex]
    if (!date) return

    const scenarioValue = row[scenarioIndex]
    const isForecastRow = !scenarioValue
    const filtered = scenario.find((row) => {
      const isMatchingDate = row["Date"] === date
      if (isForecastRow) return isMatchingDate

      // for scenario rows, we need to match both the date and the scenario value
      return isMatchingDate && row["Scenario"] === scenarioValue
    })
    if (!filtered) return
    if (filtered["Value"]) row[valueIndex] = filtered["Value"]
  })
  return mergedData
}
